const commonColumns = [
  {
    colKey: "level",
    colValue: "Proficiency Level",
    select: true,
    dynamic: true,
    width: 150,
  },
  {
    colType: "aiDescription",
    colKey: "description",
    colValue: "Description",
    dynamic: true,
    width: 260,
    includeGenAiButton: true,
  },
  {
    colType: "aiDescription",
    colKey: "knowledge",
    colValue: "Knowledge",
    dynamic: true,
    width: 260,
    includeGenAiButton: true,
  }
];

const levelIdColumn = [
    {
    colKey: "levelId",
    colValue: "ID",
    dynamic: false,
    width: 60,
  }
]

const actionButtons = [
  {
    colKey: "buttonEdit",
    saveBtn: false,
    colValue: "",
    dynamic: false,
    width: 30,
  },
  {
    colKey: "buttonDelete",
    colValue: "",
    dynamic: false,
    width: 30,
  }
];

const abilityColumn = {
  colKey: "ability",
  colValue: "Abilities",
  dynamic: true,
  width: 200,
};

export const Skill_Update_Proficiencies_Table = [
  ...levelIdColumn,
  ...commonColumns.slice(0, 2),
  abilityColumn,
  ...commonColumns.slice(2),
  ...actionButtons,
];

export const Skill_Update_Proficiencies_TableV2 = [
  ...commonColumns
];

